import type { JSX, PropsWithChildren } from 'react';

import { Box, Flex } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';

import { Label } from '../Label';

import { labelContainerStyles, messageContainerStyles, messageTextStyles } from './styles';

type Props = PropsWithChildren<{
	qaSelectorLabel: string;
	qaSelectorMessage: string;
	label: string;
	message: string;
}>;

export function RadioLabel({ qaSelectorLabel, qaSelectorMessage, label, message, children }: Props): JSX.Element {
	return (
		<Box sx={labelContainerStyles}>
			<Label qaSelectorLabel={qaSelectorLabel} label={label} />
			<Flex sx={messageContainerStyles}>
				<Text data-qa={qaSelectorMessage} size="small" sx={messageTextStyles}>
					{message}
				</Text>
				{children}
			</Flex>
		</Box>
	);
}
